import ForgetPassword from "../components/forgetPassword";

const Forgetpassword=()=>
{
   return  (
        <ForgetPassword/>
    );
}

export default Forgetpassword